var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("message.reference") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.ref_type,
                      expression: "form.ref_type"
                    }
                  ],
                  staticClass: "form-control form-control-sm custom-select",
                  attrs: { disabled: true },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "ref_type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "po" } }, [
                    _vm._v(_vm._s(_vm.$t("documents.po")))
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "so" } }, [
                    _vm._v(_vm._s(_vm.$t("documents.so")))
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "in" } }, [
                    _vm._v(_vm._s(_vm.$t("documents.in")))
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "ex" } }, [
                    _vm._v(_vm._s(_vm.$t("documents.ex")))
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "prl" } }, [
                    _vm._v(_vm._s(_vm.$t("documents.prl")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                [_c("label", [_vm._v(_vm._s(_vm.$t("message.series")))])],
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "form-control form-control-sm custom-select",
                    attrs: { disabled: true }
                  },
                  [_c("option", [_vm._v(_vm._s(_vm.form.ref_code))])]
                )
              ],
              2
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          [
            _c("section-title", { attrs: { title: _vm.sectionHeaderRefCode } }),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _vm.form.ref_type == "po" || _vm.form.ref_type == "in"
                ? _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _vm.form.ref_type == "po"
                        ? [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.vendor")))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control form-control-sm",
                              attrs: { disabled: true, type: "text" },
                              domProps: {
                                value: _vm.form.partner.vendor
                                  ? _vm.form.partner.vendor.vendor_name
                                  : ""
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.form.ref_type == "in"
                        ? [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("message.customer")))
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control form-control-sm",
                              attrs: { disabled: true, type: "text" },
                              domProps: {
                                value: _vm.form.partner.customer
                                  ? _vm.form.partner.customer.customer_name
                                  : ""
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("message.debttotal")))]),
                _vm._v(" "),
                _vm.docInfo.po
                  ? _c("input", {
                      staticClass: "form-control form-control-sm text-info",
                      attrs: { disabled: true, type: "text" },
                      domProps: {
                        value: _vm.getDebtPurchaseAmount(_vm.docInfo.po)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.docInfo.ex
                  ? _c("input", {
                      staticClass: "form-control form-control-sm text-info",
                      attrs: { disabled: true, type: "text" },
                      domProps: {
                        value: _vm.getDebtExpenseAmount(_vm.docInfo.ex)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.docInfo.in
                  ? _c("input", {
                      staticClass: "form-control form-control-sm text-info",
                      attrs: { disabled: true, type: "text" },
                      domProps: {
                        value: _vm.getDebtInvoiceAmount(_vm.docInfo.in)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.docInfo.prl
                  ? _c("input", {
                      staticClass: "form-control form-control-sm text-info",
                      attrs: { disabled: true, type: "text" },
                      domProps: {
                        value: _vm.getDebtPayslipAmount(_vm.docInfo.prl)
                      }
                    })
                  : _vm._e()
              ])
            ])
          ]
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "mb-0" }, [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding" },
        [
          _c("section-title", {
            attrs: { title: _vm.$t("message.infopayment") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-2" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.pe_type,
                      expression: "form.pe_type"
                    }
                  ],
                  staticClass: "form-control form-control-sm custom-select",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "pe_type",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "cash" } }, [
                    _vm._v(_vm._s(_vm.$t("message.cash")))
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "card" } }, [
                    _vm._v(_vm._s(_vm.$t("message.creditcard")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", [
                _vm._v(
                  _vm._s(_vm.$t("message.paidamount", { string: _vm.currency }))
                )
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.pe_amount,
                    expression: "form.pe_amount"
                  }
                ],
                ref: "pe_amount",
                staticClass:
                  "form-control form-control-sm number-only text-select-all",
                class: [_vm.bindClass.pe_amount],
                attrs: { type: "text" },
                domProps: { value: _vm.form.pe_amount },
                on: {
                  keypress: _vm.numberOnly,
                  keyup: function($event) {
                    _vm.form.pe_amount = _vm.setToValidNumber(
                      _vm.form.pe_amount
                    )
                  },
                  blur: function($event) {
                    _vm.form.pe_amount = _vm.setToCustomDigitsNumber(
                      _vm.form.pe_amount
                    )
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "pe_amount", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.pe_note,
                    expression: "form.pe_note"
                  }
                ],
                staticClass: "form-control form-control-sm",
                staticStyle: { "min-height": "90px" },
                attrs: { placeholder: _vm.$t("placeholder.note") },
                domProps: { value: _vm.form.pe_note },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "pe_note", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "vs-checkbox",
                  {
                    staticStyle: {
                      float: "left",
                      position: "relative",
                      top: "0",
                      left: "-5px"
                    },
                    attrs: { color: "#A3CA76" },
                    model: {
                      value: _vm.form.pe_ispaid,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pe_ispaid", $$v)
                      },
                      expression: "form.pe_ispaid"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("message.ispaid")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59fbd9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59fbd9e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/FormPaymentEntry.vue
// module id = null
// module chunks = 